export const toggleFilter = (filter_group_id, value_id, reset = false, filter_type = 'checkbox') =>
    function get(dispatch) {
        dispatch({
            type: 'SELECTED_FILTERS_TOGGLE',
            data: {filter_group_id, value_id, reset, filter_type}
        });
    };
